//libs
import { styled } from '@nykaa/ui-components';
import { Link } from 'react-router-dom';

//constants
import { COLORS, FOCUS_VISIBILITY_CSS } from 'shared/styles/base';

//components
import ImageV2 from 'shared/components/ImageV2';

export const Notification = styled(Link)`
  display: block;
  text-decoration: none;
  margin: ${({ theme }) => `${theme.spacing.spacing40} 0 0 0`};
  ${({ theme }) => theme.typography.subTitleSmall};
  color: ${COLORS.BRAND_PRIMARY_100};

  .icon {
    display: inline-block;
    margin-left: ${({ theme }) => theme.spacing.spacing10};
    transform: rotate(180deg);
    font-size: 10px;
    cursor: pointer;
  }
`;

export const LoginData = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: ${({ theme }) => theme.spacing.spacing120};
`;
export const LoginMessages = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  white-space: nowrap;
  margin-bottom: ${({ theme }) => theme.spacing.spacing60};
  cursor: pointer;
  
  ${FOCUS_VISIBILITY_CSS}
`;

export const LoginNameMsg = styled.p`
  ${({ theme }) => theme.typography.titleXLarge}
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
`;

export const HorizontalLine = styled.p`
  width: 100%;
  height: 0.93px;
  background: ${({ theme }) => theme.colors.primary};
  opacity: 0.16;
  margin: 0;
  position: relative;
  top: 8px;
`;

export const GoToProfile = styled.button`
  border: 0;
  outline: 0;
  background: none;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%;
`;

export const ProfileImage = styled(ImageV2)`
  width: 64px;
  height: 64px;
  display: block;
  border-radius: ${({ theme }) => theme.borders.radiusFull};
  object-fit: cover;
`;

export const GreetingMessages = styled.div`
  width: calc(100% - 82px);
`;
export const StatusMessage = styled.p<{ isLoggedIn: boolean; }>`
  margin: 0;
  white-space: nowrap;
  margin-right: ${({ theme }) => theme.spacing.spacing80};
  ${({ isLoggedIn, theme }) =>
    isLoggedIn
      ? `color: ${theme.colors.textSecondary};
          ${theme.typography.bodyMedium}
        `
      : `width: fit-content;
          color: ${theme.colors.secondary};
          ${theme.typography.bodyMedium}
        `}
  cursor: pointer;
  
  ${FOCUS_VISIBILITY_CSS}
`;

export const StatusContainer = styled.div`
  display: flex;
  margin-right: ${({ theme }) => theme.spacing.spacing80};
`;

export const TopSectionContainer = styled.div`
  height: 186px;
  display: flex;
  flex: auto;
  padding: 16px 20px 91px;
  margin: -20px -20px;
  background: url('https://asset.footlocker.co.in/footlocker-images/rewards_bg.svg') no-repeat;
  background-size: cover;
  ${({ theme }) => `box-shadow: ${theme.elevations.shadow100};
`};
  z-index: 4;
  .greeting-msg {
    color: white;
    flex: 50%;
    align-self: left;
  }
`;

export const ImageSection = styled.div`
  height: fit-content;
  width: auto;
  display: flex;
  flex: auto;
  flex-direction: column;
  margin-bottom: 14px;
  align-items: center;
  z-index: 4;
  flex: 50%;
  flex-direction: row-reverse;
  align-self: right;
`;

export const ProfileImageRewards = styled(ProfileImage)`
  height: 90px;
  max-width: 90px;
  width: 101px;
  display: flex;
  border-radius: 100%;
  flex: auto;
  background: white;
  z-index: 4;
`;

// added

export const ProfileDetailsSection = styled.div<{ loading?: boolean; error?: boolean; }>`
  height: auto;
  position: relative;
  display: flex;
  margin: -56px 4px 24px;
  flex: auto;
  flex-direction: column;
  background: white;
  border-radius: 8px;
  border: 1px solid #f8f5f5;
  ${({ theme }) => `box-shadow: ${theme.elevations.shadow100};
  padding: 16px;
`};
  ${({ loading }) =>
    loading &&
    `
    min-height: 122.5px;
  `}
  ${({ error }) =>
    error &&
    `
    margin-top: -22px;
    padding-top: 0;
  `}
  z-index: 4;
`;

export const HeaderContainer = styled.div`
  ${({ theme }) => `
  margin-left: ${theme.spacing.spacing60};
  align-self: baseline;
`}
`;

export const HeaderText = styled.img`
  width: 118px;
  height: 24px;
  background-repeat: no-repeat;
`;

export const FirstSection = styled.div`
  ${({ theme }) => theme.typography.titleSmall};
  ${({ theme }) => `
      color: ${theme.colors.primary};
    `}
  display: flex;
  flex-direction: row;
  padding: 0 0 12px 0;
  border-bottom: 0.5px solid #0000001a;
`;

export const SecondSection = styled.div`
  ${({ theme }) => theme.typography.titleSmall};
  ${({ theme }) => `
      color: ${theme.colors.primary};
    `}
  display: flex;
  padding: 12px 0;
  border-bottom: 0.5px solid #0000001a;
`;

export const ThirdSection = styled.div`
  ${({ theme }) => theme.typography.titleSmall};
  ${({ theme }) => `
      color: ${theme.colors.primary};
    `}
  display: flex;
  padding-top: 16px;
`;

export const RewardsHeading = styled.div`
  ${({ theme }) => theme.typography.buttonMedium};
  ${({ theme }) => `
      color: ${theme.colors.primary};
  `};
`;

export const MemberSince = styled.div`
  ${({ theme }) => theme.typography.bodySmall};
  ${({ theme }) => `
      color: ${theme.colors.primary};
    `};
`;

export const PointsSection = styled.div`
  ${({ theme }) => theme.typography.titleSmall};
  ${({ theme }) => `
      color: ${theme.colors.primary};
    `};
  flex: 0.3;
  &.first-section {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }
`;

export const Spent = styled.div`
  ${({ theme }) => theme.typography.subTitleMedium};
  ${({ theme }) => `
      color: ${theme.colors.primary};
    `};
  flex: 0.4;
  display: flex;
  width: 100%;
  justify-content: flex-end;
  align-self: flex-end;
`;

export const ViewHistory = styled.div`
  ${({ theme }) => theme.typography.subTitleMedium};
  ${({ theme }) => `
      color: ${theme.colors.primary};
    `};
  flex: 0.7;
`;

export const HistoryButton = styled.div`
  ${({ theme }) => theme.typography.titleSmall};
  ${({ theme }) => `
      color: ${theme.colors.primary};
    `};
  flex: 0.3;
  display: flex;
  width: 100%;
  justify-content: flex-end;
`;

export const RewardPointHeading = styled.div`
  ${({ theme }) => theme.typography.bodySmall};
  ${({ theme }) => `
      color: ${theme.colors.primary};
    `};
`;
export const Points = styled.div`
  ${({ theme }) => theme.typography.buttonMedium};
  ${({ theme }) => `
      color: ${theme.colors.primary};
    `};
  margin-right: 8px;
`;
export const Expiry = styled.div`
  ${({ theme }) => theme.typography.bodyXSmall};
  ${({ theme }) => `
      color: ${theme.colors.primary};
    `};
`;

export const PointsDisplay = styled.div`
  ${({ theme }) => `
      color: ${theme.colors.primary};
    `};
  display: flex;
  align-items: center;
  > div {
    margin-right: 0;
  }
`;

export const HeadingSection = styled.div`
  flex: 0.7;
`;
